<script setup>
import { useRouter } from 'vue-router'
import iconArrowLeft from '~/assets/icon_arrow_left.svg'

const props = defineProps({
  header: String,
  body: String,
  subheader: String,
  backButton: Boolean,
})

const router = useRouter()
</script>
<template>
  <div class="min-w-full flex justify-center content-center ">
    <div @click="$emit('clicked')"
      class="block mx-2 mt-2 w-96 max-w-md p-4 bg-white rounded-xl shadow-md  flex flex-col justify-start content-center mb-2">
      <div class="overflow-hidden">
        <div class="flex flex-row">
          <img class="w-7 h-7 justify-self-end cursor-pointer mt-2 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 20 20" :src="iconArrowLeft" v-if="props.backButton" @click="router.back()" />
          <div class="flex flex-col">
            <h5 class="text-lg tracking-tight text-secondary font-card pt-1.5">
              {{ props.header }}
            </h5>
            <div class="text-sm" v-if="props.subheader">{{ props.subheader }}</div>
          </div>
        </div>
        <p class="font-normal text-sm font-serif text-gray-700 text-ellipsis max-h-fit pb-1.5" v-show="props.body">
          {{ props.body }}
        </p>
        <slot />
      </div>
    </div>
  </div>
</template>